<template>
  <div class="box1">
<!--    <div class="fenge"></div>-->
    <div class="footer">
      <div class="footerBox">
        <div v-if="dates.copyright">{{dates.copyright}}</div>
        <div v-if="dates.address">地址：{{dates.address}}</div>
        <div v-if="dates.phone">电话：{{dates.phone}}</div>
        <div v-if="dates.mailbox">邮箱：{{dates.mailbox}}</div>
        <div v-if="dates.technicalSupport">技术支持：{{dates.technicalSupport}}</div>
        <div v-if="pageElements">
          <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #d2d2d2; text-decoration: none;">
            备案号：{{ pageElements }}
          </a>
        </div>
        <div v-if="text" class="ql-editor" v-html="text"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { selectBottom,getTextarea } from "@/api/template";
export default {
  name: "TemplateFooter",
  components: {},
  data() {
    return {
      dates: {copyright:'',recordNumber:'',address:'',phone:'',mailbox:'',technicalSupport:''},
      text:'',
      pageElements:''
    };
  },
  created(){
    this.init()
  },
  methods: {
    init(){
      selectBottom().then(res =>{
        if(res.data.length>0){
          this.dates = res.data[0]
          // console.log("this.dates",this.dates)
          this.getTextareaFun(res.data[0].content)
          //备案号
          this.pageElements = JSON.parse(window.localStorage.getItem("pageElements")).recordNumber 
        }
      }).catch(() =>{})
    },
    getTextareaFun(journalisContent){
      let params = {
        "journalisContent":journalisContent
      }
      getTextarea(params).then(res =>{
        this.text = res.data.dataHtml
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.fenge{
  background-color: #333333;
  height: 30px;
  margin-top: 20px;
  clear: both;
}
.footer{
  position: relative;
  z-index: 1;
  background-color: #333333;
  padding: 20px 0;
  clear: both;
  .footerBox{
    width: 1200px;
    margin: 0 auto;
    color: #d2d2d2;
    font-size: 16px;
    line-height: 30px;
    span{
      margin-right: 30px;
    }
  }
}
</style>
